module.exports = __webpack_public_path__ + "img/frame (92).16e89081.jpg";